


































































































































    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { VendorDetail, Vendor, OcrMappingDataViewModel } from '@/models/accounting/vendor';
    import common from '@/services/common';
    import { FileHelper } from '@/helper/file.helper';
    import VueUploadComponent from 'vue-upload-component';
    import { Base } from '@/components/common/base';
    import {vendorService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    FileUpload: VueUploadComponent,
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class InvoiceFieldsDetailPage extends Base {
  public vendorNumber: string = '';
  public selectedFiles: any = [];
  public dragclass: string = '';
  public files: any = [];
  public dragging: boolean = false;
  public attachmentsList: any = [];
  public vendorDetail: VendorDetail = {
    vendorNumber: '',
  };
  public chargeAccounts: any[] = [];
  public loading: boolean = false;
  public requestProgress: boolean = false;
  public vendorLoading: boolean = false;
  public disableSaveButton: boolean = false;
  public accountLoading: boolean = false;
  public ocrMapping: OcrMappingDataViewModel = {
    vendorName: '',
    address: '',
    invoiceDate: '',
    invoiceNumber: '',
    description: '',
    item: '',
    amount: '',
    tax: '',
    total: '',
  };
  public vendor: Vendor = {
    vendorName: '',
    addressLine1: '',
    city: '',
    phone: '',
    state: '',
    vendorNumber: '',
    zip: '',
    attachments: [],
    glCompanyName: '',
    updatedType: 'MappingFields',
    ocrMapping: this.ocrMapping,
  };
  public constants = {
    tenantId: 0,
    enterpriseId: 0,
    glCompanyName: '',
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToVendorsList') {
    // this.$router.push({ name: 'vendors.list' });
    if (history.state && history.length > 1) {
                this.$router.back();
                } else {
                this.$router.push({ name: 'vendors.list' });
                }
    }
    if (methodName === 'save') {
      this.saveVendorDetails();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('invoiceFieldsDetailPage.titleBackToVendorsList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('invoiceFieldsDetailPage.labelBack'),
      click: 'backToVendorsList',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'vendorList');
    
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.vendorNumber = this.$route.params.vendorNumber;
    this.getVendorDetail();
    this.getChargeAccounts();
  }

  public async validateAutoPay(): Promise<void> {
    window.setInterval(() => {
      if (this.vendorDetail.allowAutoPay) {
        this.vendorDetail.allowAutoApproval = true;
      }
    }, 1000);
  }
  public async validateAutoApproval(): Promise<void> {
    window.setInterval(() => {
      if (!this.vendorDetail.allowAutoApproval) {
        this.vendorDetail.allowAutoPay = false;
      }
    }, 1000);
  }

  public async saveVendorDetails(): Promise<void> {
    if (!(await this.validateForm())) {
      return;
    }
    this.requestProgress = true;
    this.disableSaveButton = true;
    this.$emit('update:progress', this.requestProgress);

    this.vendor.id = this.vendorDetail.id;
    this.vendor.vendorName = this.vendorDetail.vendorName;
    this.vendor.city = this.vendorDetail.billCity;
    this.vendor.state = this.vendorDetail.billStateCode;
    this.vendor.glCompanyId = this.vendorDetail.glCompanyId;
    this.vendor.companyNo = this.vendorDetail.companyNo;
    this.vendor.zip = this.vendorDetail.zip;
    this.vendor.federalTaxId = this.vendorDetail.federalTaxId;
    this.vendor.vendorType = this.vendorDetail.vendorType;
    this.vendor.vendorNumber = this.vendorDetail.vendorNumber;
    this.vendor.addressLine1 = this.vendorDetail.billAddressLine1;
    this.vendor.monthlyAutoApprovalLimit = this.vendorDetail.monthlyAutoApprovalLimit;
    this.vendor.monthlyApprovedAmount = this.vendorDetail.monthlyApprovedAmount;
    this.vendor.allowAutoApproval = this.vendorDetail.allowAutoApproval;
    this.vendor.allowAutoPay = this.vendorDetail.allowAutoPay;
    this.vendor.accountNumber = this.vendorDetail.accountNumber;
    // Ocr Mapping
    this.vendor.ocrMapping.vendorName = this.ocrMapping.vendorName;
    this.vendor.ocrMapping.address = this.ocrMapping.address;
    this.vendor.ocrMapping.invoiceDate = this.ocrMapping.invoiceDate;
    this.vendor.ocrMapping.invoiceNumber = this.ocrMapping.invoiceNumber;
    this.vendor.ocrMapping.description = this.ocrMapping.description;
    this.vendor.ocrMapping.item = this.ocrMapping.item;
    this.vendor.ocrMapping.amount = this.ocrMapping.amount;
    this.vendor.ocrMapping.tax = this.ocrMapping.tax;
    this.vendor.ocrMapping.total = this.ocrMapping.total;
    try {
      await vendorService.saveVendorAsync(this.vendor);
      this.showAlert(
        true,
        this.$parent.$t('invoiceFieldsDetailPage.alertMappedDetailSaved')
      );
      this.$router.push({
        name: 'vendors.list',
      });
    } finally {
      this.disableSaveButton = false;
      this.requestProgress = false;
      this.$emit('update:progress', this.requestProgress);
    }
  }

  public async getVendorDetail(): Promise<void> {
    try {
      this.loading = true;
      const resp = await vendorService.getVendorDetailAsync(this.vendorNumber);
      if (resp) {
        this.vendorDetail = resp;
        if (resp.ocrMapping !== undefined) {
          this.ocrMapping = resp.ocrMapping;
        }
        if (!this.vendorDetail) {
          this.showAlert(
            false,
            this.$parent.$t('invoiceFieldsDetailPage.alertSomeErrorOccurred')
          );
        }
      }
    } finally {
      this.loading = false;
    }
  }

  public async getChargeAccounts(): Promise<void> {
    this.setError(
      'Account Number',
      this.$parent.$t('invoiceFieldsDetailPage.loadingAccounts') as string
    );
    try {
      this.accountLoading = true;
      const chargeAccounts = await vendorService.getStoreChargeAccountsAsync();
      this.removeError('Account Number');
      this.chargeAccounts = chargeAccounts.results;
    } catch (e) {
      this.setError(
        'Account Number',
        this.$parent.$t('invoiceFieldsDetailPage.accountsNotFound') as string
      );
      this.chargeAccounts = [];
    } finally {
      this.accountLoading = false;
    }
  }

  public setError(fieldName, errorMsg) {
    this.$validator.errors.add({ field: fieldName, msg: errorMsg });
  }

  public removeError(fieldName) {
    this.$validator.errors.remove(fieldName);
  }
}
